// extracted by mini-css-extract-plugin
export default {"mainDashBoard":"MainDashboard_mainDashBoard__aNSP3"};